"use strict";

var _jquery = require("jquery");
var _jquery2 = _interopRequireDefault(_jquery);
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
(0, _jquery2.default)(function () {
  (0, _jquery2.default)('.template-section-sku-slider:not(.section-sku-slider-big) .slider-product').each(function (index, element) {
    var tagArrowLeft = (0, _jquery2.default)(element).data('tag-arrow-left');
    var tagArrowRight = (0, _jquery2.default)(element).data('tag-arrow-right');
    (0, _jquery2.default)(element).on('init', function (event, slick, direction) {
      (0, _jquery2.default)('.slick-slide a', (0, _jquery2.default)(element)).each(function (index2, element2) {
        var id = (0, _jquery2.default)(element2).data('id');
        (0, _jquery2.default)(element2).attr('id', id);
      });
      checkSliderNote((0, _jquery2.default)(element));
    });
    (0, _jquery2.default)(element).on('breakpoint', function (event, slick, breapoint) {
      checkSliderNote((0, _jquery2.default)(element));
    });
    (0, _jquery2.default)(element).slick({
      dots: true,
      arrows: true,
      mobileFirst: true,
      slidesToShow: 2.5,
      slidesToScroll: 2,
      infinite: false,
      appendDots: (0, _jquery2.default)('.container-dots', (0, _jquery2.default)(element).closest('.row')),
      prevArrow: (0, _jquery2.default)('.button-arrow-prev', (0, _jquery2.default)(element).closest('.row')),
      nextArrow: (0, _jquery2.default)('.button-arrow-next', (0, _jquery2.default)(element).closest('.row')),
      responsive: [{
        breakpoint: 540,
        settings: {
          slidesToShow: 2.5,
          slidesToScroll: 2
        }
      }]
    });
    checkSliderNote((0, _jquery2.default)(element));
  });
  function checkSliderNote($element) {
    var $row = (0, _jquery2.default)($element).closest('.row');
    if ((0, _jquery2.default)('.container-arrows-products', $row).text().trim() == '') (0, _jquery2.default)('.slider-note', $row).hide();else (0, _jquery2.default)('.slider-note', $row).show();
  }
});